export function userMustNotInsertTid(cube) {
  return cube === null || cube.Attributes.filter(attr => attr.IsTid).length === 0;
}



// WEBPACK FOOTER //
// ./src/scenes/data-manager/attribute-file/utils.js